/**
 * @file コンポーネント：フル動画ページタイムラインコメント DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル設定読み込み
import { StyledComment, StyledCommentTime, StyledCommentText } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledComment>
            {/* コメント時間 */}
            <StyledCommentTime>{props.time}</StyledCommentTime>
            {/* サムネイル */}
            {props.thumbnail && (
                <img
                    src={props.thumbnail.src}
                    style={props.thumbnail.style}
                    alt="thumbnail"
                />
            )}
            {/* コメント本文 */}
            <StyledCommentText ref={props.refText}>
                {props.text}
            </StyledCommentText>
        </StyledComment>
    );
};
